/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class PackageCategoryDto {
  public code: string = undefined;
  public descriptionSv: string = undefined;

  //<custom-body>
  constructor(json: PackageCategoryDto) {
    this.code = json.code;
    this.descriptionSv = json.descriptionSv;
  }

  public get displayName(): string {
    return `${this.code} - ${this.descriptionSv}`;
  }

  public get description(): string {
    return this.descriptionSv;
  }
  //</custom-body>
}
